(() => {
  const controllerUrl = document.currentScript?.src;
  const STYLE_URL = "https://cdn.shopify.com/s/files/1/0823/3146/8024/t/24/assets/yizcho-exterior-transition-v01.css?v=1786778868";
  if (controllerUrl) {
    const expectedStyleUrl = new URL(STYLE_URL, document.baseURI).href;
    const existingStyle = document.querySelector('link[href*="yizcho-exterior-transition-v01.css"]');
    if (existingStyle) {
      if (existingStyle.href !== expectedStyleUrl) existingStyle.href = expectedStyleUrl;
      existingStyle.dataset.yizchoExteriorTransitionV01 = "true";
    } else {
      const style = document.createElement("link");
      style.rel = "stylesheet";
      style.dataset.yizchoExteriorTransitionV01 = "true";
      style.href = expectedStyleUrl;
      document.head.append(style);
    }
  }

  /* A cached theme section may have booted an older controller first. Always
     upgrade its stylesheet above, then keep a single event controller. */
  if (window.__YIZCHO_EXTERIOR_TRANSITION_V01__) return;
  window.__YIZCHO_EXTERIOR_TRANSITION_V01__ = true;

  const MEDIA = Object.freeze({
    "HOUSE-01": Object.freeze({
      final: "https://cdn.shopify.com/s/files/1/0823/3146/8024/t/24/assets/yizcho-house-01-exterior-final-v05.webp?v=1786775490",
      width: 720,
      height: 1280,
      replay: Object.freeze({ x: 0.455, y: 0.66, width: 0.25, height: 0.24 }),
    }),
    "HOUSE-03": Object.freeze({
      video: "https://cdn.shopify.com/s/files/1/0823/3146/8024/t/24/assets/yizcho-house-03-black-white-cat-house-mobile-v04.mp4?v=1786795362",
      entry: "https://cdn.shopify.com/s/files/1/0823/3146/8024/t/24/assets/yizcho-house-03-exterior-first-v04.webp?v=1786775493",
      final: "https://cdn.shopify.com/s/files/1/0823/3146/8024/t/24/assets/yizcho-house-03-exterior-final-v05.webp?v=1786796366",
      width: 720,
      height: 1280,
      replay: Object.freeze({ x: 0.21, y: 0.205, width: 0.24, height: 0.17 }),
    }),
  });

  const boot = () => {
    const body = document.body;
    const layer = document.querySelector("#closeup-layer");
    const closeupImage = document.querySelector("#closeup-image");
    const video = document.querySelector("#exterior-scene-video");
    const replay = document.querySelector("#exterior-scene-replay");
    const audio = document.querySelector("#exterior-scene-audio");
    const roomEntry = document.querySelector("#room-entry");
    if (!body || !layer || !closeupImage || !video || !replay) return;

    const finalFrame = document.querySelector("#exterior-scene-final-frame") || (() => {
      const image = document.createElement("img");
      image.id = "exterior-scene-final-frame";
      image.className = "exterior-scene-final-frame";
      image.alt = "";
      image.setAttribute("aria-hidden", "true");
      image.decoding = "async";
      image.draggable = false;
      image.hidden = true;
      video.insertAdjacentElement("afterend", image);
      return image;
    })();

    video.dataset.mobileFinalPoster = MEDIA["HOUSE-01"].final;
    video.dataset.house03MobilePoster = MEDIA["HOUSE-03"].entry;
    video.dataset.house03MobileFinalPoster = MEDIA["HOUSE-03"].final;

    let selectedHouse = null;
    let completed = false;
    let restarting = false;
    let audibleReplay = false;
    let clearTimer = 0;
    let replayFallbackTimer = 0;
    let entryPlaybackTimer = 0;

    const isMobile = () => window.innerWidth < 760;
    const mediaFor = (houseId = selectedHouse) => MEDIA[houseId] || null;
    const entryFor = (houseId = selectedHouse) => {
      if (houseId === "HOUSE-03") return MEDIA[houseId].entry;
      if (houseId === "HOUSE-01") return video.dataset.mobilePoster || video.poster;
      return "";
    };

    const primeImage = (url) => {
      if (!url) return;
      const image = new Image();
      image.decoding = "async";
      image.src = url;
      image.decode?.().catch(() => {});
    };

    Object.values(MEDIA).forEach((media) => {
      primeImage(media.entry);
    });
    primeImage(entryFor("HOUSE-01"));

    const positionReplay = (houseId = selectedHouse) => {
      const media = mediaFor(houseId);
      if (!media || !isMobile()) return;
      const rect = layer.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      const renderedHeight = rect.height;
      const renderedWidth = Math.max(rect.width, media.width * (renderedHeight / media.height));
      const renderedLeft = (rect.width - renderedWidth) * 0.5;
      const x = renderedLeft + renderedWidth * media.replay.x;
      const y = renderedHeight * media.replay.y;
      layer.style.setProperty("--exterior-scene-replay-x", `${x}px`);
      layer.style.setProperty("--exterior-scene-replay-y", `${y}px`);
      layer.style.setProperty(
        "--exterior-scene-replay-width",
        `${Math.max(52, renderedWidth * media.replay.width)}px`,
      );
      layer.style.setProperty(
        "--exterior-scene-replay-height",
        `${Math.max(72, renderedHeight * media.replay.height)}px`,
      );
    };

    const ensureEntryPlayback = (houseId = selectedHouse) => {
      if (!houseId || selectedHouse !== houseId || !isMobile() || completed || body.classList.contains("has-room")) return;
      const media = mediaFor(houseId);
      if (houseId === "HOUSE-03") {
        if (!media?.video) return;
        const reachedVisualEnd = Number.isFinite(video.duration)
          && video.duration > 0
          && video.currentTime >= video.duration - 0.08;
        if (reachedVisualEnd) {
          exposeFinal(houseId);
          return;
        }
        if (!body.classList.contains("has-house03-mobile-video")) body.classList.add("has-house03-mobile-video");
        if (!body.classList.contains("has-exterior-scene-video")) body.classList.add("has-exterior-scene-video");
        if (body.classList.contains("house03-video-ended")) body.classList.remove("house03-video-ended");
        if (!layer.classList.contains("has-exterior-scene-video")) layer.classList.add("has-exterior-scene-video");
        if (!layer.classList.contains("is-exterior-scene-playing")) layer.classList.add("is-exterior-scene-playing");
        if (layer.classList.contains("is-exterior-scene-held")) layer.classList.remove("is-exterior-scene-held");
        if (layer.classList.contains("has-room-entry")) layer.classList.remove("has-room-entry");
        if (roomEntry) {
          if (!roomEntry.hidden) roomEntry.hidden = true;
          if (!roomEntry.disabled) roomEntry.disabled = true;
        }
        if (!replay.hidden) replay.hidden = true;
        if (!replay.disabled) replay.disabled = true;
        if (video.hidden) video.hidden = false;
        video.loop = false;
        video.playsInline = true;
        video.dataset.sceneHouse = houseId;
        if (video.getAttribute("src") !== media.video) {
          video.src = media.video;
          video.poster = media.entry;
          video.load();
        }
        video.defaultMuted = !audibleReplay;
        video.muted = !audibleReplay;
        video.toggleAttribute("muted", !audibleReplay);
      } else if (houseId === "HOUSE-01") {
        if (video.hidden || !video.getAttribute("src")) return;
        video.defaultMuted = true;
        video.muted = true;
        video.setAttribute("muted", "");
      }
      if (!video.paused && !video.ended) return;
      const playback = video.play();
      playback?.catch(() => {
        if (selectedHouse !== houseId || completed || body.classList.contains("has-room")) return;
        video.defaultMuted = true;
        video.muted = true;
        video.setAttribute("muted", "");
        video.play?.().catch(() => {});
      });
    };

    const clearFinal = () => {
      completed = false;
      restarting = false;
      layer.classList.remove("is-exterior-scene-held");
      finalFrame.hidden = !selectedHouse || !isMobile();
    };

    const releaseExteriorSelection = () => {
      selectedHouse = null;
      completed = false;
      restarting = false;
      audibleReplay = false;
      window.clearTimeout(clearTimer);
      window.clearTimeout(replayFallbackTimer);
      window.clearTimeout(entryPlaybackTimer);
      body.classList.remove(
        "has-exterior-scene-video",
        "has-house03-mobile-video",
        "house03-video-ended",
      );
      layer.classList.remove(
        "has-exterior-scene-video",
        "is-exterior-scene-playing",
        "is-exterior-scene-ready",
        "is-exterior-scene-held",
        "has-room-entry",
      );
      layer.style.removeProperty("--exterior-scene-hold-poster");
      delete layer.dataset.exteriorSceneHouse;
      closeupImage.classList.remove("is-exterior-scene-poster");
      finalFrame.hidden = true;
      replay.hidden = true;
      replay.disabled = true;
      if (roomEntry) {
        roomEntry.hidden = true;
        roomEntry.disabled = true;
      }
      video.pause();
      video.defaultMuted = true;
      video.muted = true;
      video.setAttribute("muted", "");
      video.hidden = true;
      video.removeAttribute("src");
      video.removeAttribute("poster");
      delete video.dataset.sceneHouse;
      video.load();
      if (audio) {
        audio.pause();
        try { audio.currentTime = 0; } catch (_) {}
      }
    };

    const enforceHouse03PlayingControls = () => {
      if (
        selectedHouse !== "HOUSE-03"
        || completed
        || video.paused
        || video.ended
        || !roomEntry
      ) return;
      if (!roomEntry.hidden) roomEntry.hidden = true;
      if (!roomEntry.disabled) roomEntry.disabled = true;
      if (layer.classList.contains("has-room-entry")) layer.classList.remove("has-room-entry");
      if (!replay.hidden) replay.hidden = true;
      if (!replay.disabled) replay.disabled = true;
    };

    const syncEntryPoster = () => {
      if (!selectedHouse || !isMobile() || completed || restarting || body.classList.contains("has-room")) return;
      const entry = entryFor(selectedHouse);
      const final = mediaFor(selectedHouse)?.final;
      layer.dataset.exteriorSceneHouse = selectedHouse;
      if (entry) {
        closeupImage.classList.add("is-exterior-scene-poster");
        if (closeupImage.getAttribute("src") !== entry) closeupImage.src = entry;
        if (video.getAttribute("poster") !== entry) video.poster = entry;
      }
      const videoHasStarted = video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA
        || video.currentTime > 0
        || video.ended;
      if (final && videoHasStarted && finalFrame.getAttribute("src") !== final) {
        finalFrame.fetchPriority = "high";
        finalFrame.src = final;
      }
      /* Keep the decoded final frame in layout beneath the video. Its opacity
         stays at zero until exposeFinal(), but its full-viewport geometry can
         settle while the video plays instead of visibly sliding into place
         after `ended`. */
      finalFrame.hidden = false;
    };

    const exposeFinal = (houseId = selectedHouse) => {
      const media = mediaFor(houseId);
      if (!media || !isMobile() || body.classList.contains("has-room")) return;
      selectedHouse = houseId;
      completed = true;
      restarting = false;
      audibleReplay = false;
      if (finalFrame.getAttribute("src") !== media.final) finalFrame.src = media.final;
      finalFrame.hidden = false;

      const commit = () => {
        if (!completed || selectedHouse !== houseId || body.classList.contains("has-room")) return;
        layer.classList.add("has-exterior-scene-video", "is-exterior-scene-ready", "is-exterior-scene-held");
        layer.classList.remove("is-exterior-scene-playing");
        if (!body.classList.contains("has-exterior-scene-video")) {
          body.classList.add("has-exterior-scene-video");
        }
        if (houseId === "HOUSE-03" && roomEntry) {
          if (!body.classList.contains("has-house03-mobile-video")) body.classList.add("has-house03-mobile-video");
          if (!body.classList.contains("house03-video-ended")) body.classList.add("house03-video-ended");
          if (!layer.classList.contains("has-room-entry")) layer.classList.add("has-room-entry");
          if (roomEntry.hidden) roomEntry.hidden = false;
          if (roomEntry.disabled) roomEntry.disabled = false;
          if (roomEntry.dataset.entryType !== "window") roomEntry.dataset.entryType = "window";
          const entryLabel = "Tap the second-floor window to enter the Cat Motion Album";
          if (roomEntry.getAttribute("aria-label") !== entryLabel) roomEntry.setAttribute("aria-label", entryLabel);
          const hint = document.querySelector("#room-entry-hint");
          const label = document.querySelector("#room-entry-label");
          if (hint && hint.textContent !== "TAP THE SECOND-FLOOR WINDOW") hint.textContent = "TAP THE SECOND-FLOOR WINDOW";
          if (label && label.textContent !== "Enter the Cat Motion Album") label.textContent = "Enter the Cat Motion Album";
        }
        if (replay.hidden) replay.hidden = false;
        if (replay.disabled) replay.disabled = false;
        replay.setAttribute(
          "aria-label",
          houseId === "HOUSE-03"
            ? "Replay the black-and-white cat's run and rooftop leap with music"
            : "Replay the white cat's yawn, stretch, and nap",
        );
        positionReplay(houseId);
      };

      if (finalFrame.complete && finalFrame.naturalWidth > 0) {
        commit();
        return;
      }
      const decoding = finalFrame.decode?.();
      if (decoding) {
        decoding.then(commit).catch(() => {
          finalFrame.addEventListener("load", commit, { once: true });
        });
      } else {
        finalFrame.addEventListener("load", commit, { once: true });
      }
    };

    const selectHouse = (houseId) => {
      // The capture listener runs before the main hotspot handler. Release any
      // previous exterior here so queued playback cannot race the direct album.
      if (houseId === "HOUSE-03" && isMobile()) { releaseExteriorSelection(); return; }
      window.clearTimeout(clearTimer);
      window.clearTimeout(entryPlaybackTimer);
      selectedHouse = MEDIA[houseId] ? houseId : null;
      if (!selectedHouse || !isMobile()) {
        clearFinal();
        return;
      }
      clearFinal();
      audibleReplay = false;
      replay.hidden = true;
      replay.disabled = true;
      layer.dataset.exteriorSceneHouse = selectedHouse;
      primeImage(entryFor());
      window.requestAnimationFrame(() => {
        syncEntryPoster();
        ensureEntryPlayback(houseId);
      });
      window.queueMicrotask(() => ensureEntryPlayback(houseId));
      entryPlaybackTimer = window.setTimeout(() => ensureEntryPlayback(houseId), 700);
    };

    const fallbackReplay = () => {
      if (!selectedHouse || !isMobile() || !video.paused || body.classList.contains("has-room")) return;
      audibleReplay = selectedHouse === "HOUSE-03";
      try {
        video.currentTime = 0;
      } catch (_) {
        // A loadedmetadata retry below covers Safari's early-seek restriction.
      }
      if (selectedHouse === "HOUSE-01") {
        video.defaultMuted = true;
        video.muted = true;
        video.setAttribute("muted", "");
        if (audio) {
          try { audio.currentTime = 0; } catch (_) {}
          audio.play?.().catch(() => {});
        }
      } else {
        video.defaultMuted = false;
        video.muted = false;
        video.removeAttribute("muted");
      }
      layer.classList.add("is-exterior-scene-playing");
      const playback = video.play();
      playback?.catch(() => {
        video.defaultMuted = true;
        video.muted = true;
        video.setAttribute("muted", "");
        video.play?.().catch(() => exposeFinal(selectedHouse));
      });
    };

    document.addEventListener("click", (event) => {
      if (event.target.closest?.("#exterior-scene-replay")) {
        if (!selectedHouse || !isMobile()) return;
        clearFinal();
        restarting = true;
        audibleReplay = selectedHouse === "HOUSE-03";
        window.clearTimeout(replayFallbackTimer);
        replayFallbackTimer = window.setTimeout(fallbackReplay, 260);
        return;
      }
      const houseControl = event.target.closest?.("[data-id]");
      if (houseControl) {
        selectHouse(houseControl.dataset.id);
        return;
      }
      if (event.target.closest?.("#closeup-back, #panel-close")) {
        /* Release synchronously in the capture phase. Waiting for the close-up
           transition used to leave selectedHouse alive long enough for late
           video events to restore the full-screen poster after resetView(),
           making the transparent close-up intercept every island house. */
        releaseExteriorSelection();
      }
    }, true);

    video.addEventListener("playing", () => {
      if (!selectedHouse || !isMobile()) return;
      const replayRequested = restarting;
      window.clearTimeout(replayFallbackTimer);
      clearFinal();
      audibleReplay = selectedHouse === "HOUSE-03" && replayRequested;
      replay.hidden = true;
      replay.disabled = true;
      if (selectedHouse === "HOUSE-03" && roomEntry) {
        roomEntry.hidden = true;
        roomEntry.disabled = true;
        layer.classList.remove("has-room-entry");
      }
      layer.classList.add("has-exterior-scene-video", "is-exterior-scene-ready", "is-exterior-scene-playing");
      enforceHouse03PlayingControls();
      syncEntryPoster();
    });

    video.addEventListener("ended", () => {
      const houseId = selectedHouse || layer.dataset.exteriorSceneHouse || video.dataset.sceneHouse;
      if (MEDIA[houseId]) exposeFinal(houseId);
    });

    video.addEventListener("loadedmetadata", () => {
      if (restarting && video.paused) fallbackReplay();
    });

    let reconcilingMutations = false;
    const observer = new MutationObserver(() => {
      if (reconcilingMutations) return;
      reconcilingMutations = true;
      try {
      if (!selectedHouse || !isMobile()) return;
      if (body.classList.contains("has-room")) return;
      enforceHouse03PlayingControls();
      if (completed) exposeFinal(selectedHouse);
      else if (!restarting) {
        ensureEntryPlayback(selectedHouse);
        syncEntryPoster();
      }
      if (!body.classList.contains("has-closeup") && !body.classList.contains("has-selection")) {
        window.clearTimeout(clearTimer);
        clearTimer = window.setTimeout(() => {
          if (!body.classList.contains("has-closeup") && !body.classList.contains("has-selection")) {
            selectedHouse = null;
            clearFinal();
          }
        }, 420);
      }
      } finally {
        /* Discard records generated by our own idempotent reconciliation so
           a reflected class/boolean attribute cannot create a microtask loop. */
        observer.takeRecords();
        reconcilingMutations = false;
      }
    });
    observer.observe(body, { attributes: true, attributeFilter: ["class"] });
    observer.observe(closeupImage, { attributes: true, attributeFilter: ["src"] });
    observer.observe(video, { attributes: true, attributeFilter: ["src", "poster", "hidden"] });
    if (roomEntry) {
      observer.observe(roomEntry, { attributes: true, attributeFilter: ["hidden", "disabled"] });
    }

    window.addEventListener("resize", () => {
      if (!selectedHouse) return;
      if (!isMobile()) {
        selectedHouse = null;
        clearFinal();
      } else if (completed) {
        positionReplay(selectedHouse);
      }
    });
  };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot, { once: true });
  else boot();
})();
